.Image__container {
  display: inline-block;
}

.Image {
  object-fit: cover;
  display: inline-block;
}

.Image--aspect-ratio-custom {
  aspect-ratio: var(--brand-image-aspectRatio);
}

.Image--aspect-ratio-1-1 {
  aspect-ratio: 1 / 1;
}

.Image--aspect-ratio-16-9 {
  aspect-ratio: 16 / 9;
}

.Image--aspect-ratio-16-10 {
  aspect-ratio: 16 / 10;
}

.Image--aspect-ratio-4-3 {
  aspect-ratio: 4 / 3;
}

.Image--borderRadius-small {
  display: block;
  border-radius: var(--brand-borderRadius-small);
}

.Image--borderRadius-medium {
  display: block;
  border-radius: var(--brand-borderRadius-medium);
}

.Image--borderRadius-large {
  display: block;
  border-radius: var(--brand-borderRadius-large);
}

.Image--borderRadius-xlarge {
  display: block;
  border-radius: var(--brand-borderRadius-xlarge);
}

.Image--borderRadius-full {
  display: block;
  border-radius: var(--brand-borderRadius-full);
}
